import React from "react";
import { useGameState } from "context/GameContext";
import Jello from "react-reveal/Jello";
// Css
import classes from "./DrawPile.module.scss";

const DrawPile: React.FC = () => {
  const { drawRules } = useGameState();

  return (
    <div className={classes.container}>
      <img
        className={classes.pile}
        src="assets/img/board/draw-piles.svg"
        alt=""
      />

      {drawRules.length !== 0 && (
        <img
          className={classes.policy}
          src="assets/img/board/policy.svg"
          alt=""
        />
      )}
      <Jello spy={drawRules.length}>
        <div className={classes.badge}>{drawRules.length}</div>
      </Jello>
    </div>
  );
};

export default DrawPile;
